// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c98cbdab","732":"be119dc7"}[chunkId] + ".chunk.js";
};